module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"QuickSelect":"Quick Select reason"},"vi":{"QuickSelect":"Chọn nhanh lý do"}}')
  delete Component.options._Ctor
}
